module.exports = __webpack_public_path__ + "static/media/objective_arrow_down.82b10517.svg";